import { render } from "./Card4.vue?vue&type=template&id=4a00c0ef&ts=true"
import script from "./Card4.vue?vue&type=script&lang=ts"
export * from "./Card4.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/kemet/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__